import {defineComponent, watch, PropType} from '@vue/composition-api';

export interface AssignmentStatus {

    assigned: boolean;

    agreed: boolean;

    administrator: boolean;
}

export default defineComponent({
    props: {
        companyName: {
            type: String,
            default: null,
            required: false
        },
        organizationNumber: {
            type: String,
            required: true
        },
        limitedCompany: {
            type: Boolean,
            required: true
        },
        confirmedCompany: {
            type: Boolean,
            required: false
        },
        selfOwned: {
            type: Boolean,
            required: true
        },
        value: {
            type: Object as PropType<AssignmentStatus>,
            required: false,
            default: false
        }
    },
    setup(initProps) {

        const icon = initProps.limitedCompany ? 'company' : (!initProps.confirmedCompany ? 'question' : 'office-desk');

        watch(() => [initProps.value.assigned, initProps.value.agreed], () => {

            if (!initProps.value.assigned) {

                initProps.value.agreed = false;
            }
        });

        return {
            icon
        }
    }
});
